import React from "react";

const Sidebar = ({ activeMenu, setActiveMenu, visible, onClose, userAccess }) => {
  const menuSections = [
    {
      title: "Fixed Asset",
      code: 1300,
      items: [
        { label: "Master Aset", icon: "💻", key: "master-aset" },
        { label: "Add Asset", icon: "➕", key: "add-asset" },
      ],
    },
    {
      title: "Procurement",
      code: 1302,
      items: [
        { label: "Master Barang", icon: "📋", key: "master-barang" },
        { label: "Purchase Order", icon: "📝", key: "purchase-order" },
      ],
    },
    {
      title: "Inventory",
      code: 1301,
      items: [
        { label: "Permintaan Barang", icon: "📦", key: "permintaan-barang" },
        { label: "Purchase Request", icon: "🧾", key: "purchase-request" },
      ],
    },
    {
      title: "Finance",
      code: 1303,
      items: [
        { label: "Request Of Payment", icon: "💰", key: "pengajuan-rop" },
      ],
    },
  ];

  // 🔹 Filter menu berdasarkan akses user
  const visibleMenus = menuSections.filter((section) =>
    userAccess.includes(section.code)
  );

  if (!visibleMenus.length) {
    return (
      <div
        style={{
          padding: "20px",
          background: "#fff",
          borderRight: "1px solid #ddd",
          color: "#666",
        }}
      >
        Tidak ada menu tersedia.
      </div>
    );
  }

  // 🔹 Tentukan mode & ukuran sidebar
  const isMobile = window.innerWidth < 768;
  const sidebarWidth = isMobile ? "220px" : "280px";
  const APP_VERSION =
    process.env.REACT_APP_VERSION || "v1.0.0";

  return (
    <aside
      style={{
        position: "fixed",
        top: "64px",
        bottom: 0, // 🔥 penting (lebih stabil dari height: 100vh)
        left: visible
          ? "0"
          : isMobile
            ? `-${sidebarWidth}`
            : "0",
        width: sidebarWidth,
        background: "rgba(255,255,255,0.85)",
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
        borderRight: "1px solid rgba(0,0,0,0.05)",
        boxShadow: visible && isMobile
          ? "4px 0 20px rgba(0,0,0,0.12)"
          : "0 4px 20px rgba(0,0,0,0.04)",
        transition: "all 0.3s ease",
        zIndex: 200,
        display: "flex",
        flexDirection: "column",
      }}
    >

      {/* ================= MENU AREA ================= */}
      <div
        style={{
          flex: 1,
          overflowY: "auto",
          padding: "18px 16px",
        }}
      >
        {visibleMenus.map((section) => (
          <div key={section.title} style={{ marginBottom: "28px" }}>
            <h4
              style={{
                fontSize: "14px",
                fontWeight: "600",
                marginBottom: "12px",
                background: "linear-gradient(135deg, #05386b, #0f3057)",
                padding: "8px 12px",
                borderRadius: "8px",
                color: "#ffffff",
                letterSpacing: "0.5px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
              }}
            >
              {section.title}
            </h4>

            {section.items.map((item) => {
              const isActive = activeMenu === item.key;

              return (
                <div
                  key={item.key}
                  onClick={() => {
                    setActiveMenu(item.key);
                    if (isMobile) onClose();
                  }}
                  style={{
                    padding: "9px 12px",
                    borderRadius: "8px",
                    background: isActive
                      ? "linear-gradient(135deg, #007bff, #0056d2)"
                      : "transparent",
                    color: isActive ? "#fff" : "#333",
                    cursor: "pointer",
                    marginBottom: "8px",
                    transition: "all 0.2s ease",
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    fontWeight: isActive ? "600" : "500",
                    boxShadow: isActive
                      ? "0 4px 12px rgba(0,123,255,0.35)"
                      : "none",
                  }}
                  onMouseEnter={(e) => {
                    if (!isActive)
                      e.currentTarget.style.background = "#f1f5ff";
                  }}
                  onMouseLeave={(e) => {
                    if (!isActive)
                      e.currentTarget.style.background = "transparent";
                  }}
                >
                  <span style={{ fontSize: "18px" }}>{item.icon}</span>
                  <span style={{ flex: 1, fontSize: "14px" }}>
                    {item.label}
                  </span>
                </div>
              );
            })}
          </div>
        ))}
      </div>

      {/* ================= FOOTER ================= */}
      <div
        style={{
          padding: "14px 12px",
          borderTop: "1px solid rgba(0,0,0,0.05)",
          fontSize: "11px",
          color: "#777",
          textAlign: "center",
          background: "rgba(255,255,255,0.85)",
          backdropFilter: "blur(8px)",
        }}
      >
        <div style={{ fontWeight: 600, color: "hotpink" }}>
          © {new Date().getFullYear()} OMDC GROUP
        </div>
        <div style={{ fontWeight: 600, color: "hotpink" }}>
          All rights reserved.
        </div>
        <div style={{ marginTop: "2px", fontSize: "10px", opacity: 0.6 }}>
          Version {APP_VERSION}
        </div>
      </div>

    </aside>
  );
};

export default Sidebar;
